import { useEffect, useState } from 'react';
import { localStorageBridge } from 'shared/src/utils/bridge';

const KEY = 'LIKE_TAB_CODI_BADGE_HIDDEN';

export const useCodiTabBadge = (isStyleTabActive: boolean) => {
  const [showBadge, setShowBadge] = useState(false);

  useEffect(() => {
    let cancelled = false;
    localStorageBridge.getBoolean(KEY).then(hidden => {
      if (!cancelled) setShowBadge(!(hidden ?? false));
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (isStyleTabActive && showBadge) {
      setShowBadge(false);
      localStorageBridge.putBoolean(KEY, true);
    }
  }, [isStyleTabActive, showBadge]);

  return showBadge;
};
